var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"translation_box"},[_c('el-container',{style:({ height: _vm.Height + 'px' })},[_c('el-main',{staticStyle:{"background":"#f5f5f5"},style:({ minHeight: _vm.Height + 'px' })},[(_vm.keys == '1')?_c('UPLOAD'):_vm._e(),(_vm.keys == '2')?_c('div',[_c('REPORT')],1):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }